// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/0f83c6c8db9fe9da4974.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"ec16c557d773f971bb95","140":"c7e3ef469b12f17e35cc","141":"300cd1d59a4e5410bc75"}[chunkId] + ".chunk.js";
};